import React from "react";
import logo from "../assets/logo.png";
function SplashScreen() {
    return (
        <div className="logo2" style={{ zIndex: "5" }} >
                <img src={logo} />
        </div>
    );
};

export default SplashScreen;
